import { select } from 'd3-selection';
import getIndex from "../../../../helper/insertionSearch";
import MarkLine, { findCoordinate } from "./markLine";
import MarkNode from "./markNode";
class MarkData {
  constructor() {
    this.marks = [];
    this.markNodes = [];
    this.removeMarkLine = this.removeMarkLine.bind(this);
    this.saveMarksId = []
  }

  createMarkLine({ plotId, prevX, root, x, padding, height, xValue, curves, targetX, getYValue, getXValue, getYMarkerText, save }) {
    const markLine = new MarkLine({
      id: `${plotId}-${prevX}`,
      prevX,
      delMarkLine: this.removeMarkLine,
      getYValue,
      getXValue,
      targetX,
      xValue,
      x,
      padding,
      height,
      getYMarkerText
    })
    markLine.drawMarkLine(root);
    markLine.drawMarkNode(curves)
    this.marks.push(markLine);
    if (save) {
      this.saveMarksId.push(`${plotId}-${prevX}`)
    }
  }

  removeSaveMarkLine = () => {
    this.marks.forEach(mark => {
      if (this.saveMarksId.includes(mark.id)) {
        mark.removeMarkLine()
      }
    })
  }

  removeMarkLine(id) {
    this.marks = this.marks.filter(m => m.id !== id);
  }

  removeMarkOnCurve(hashId) {
    this.marks.forEach(mark => {
      mark.removeNode(hashId);
    })
  }

  clearAll() {
    this.marks.forEach(mark => {
      mark.removeMarkLine()
    });
  }

  redraw({ padding, height, curves }) {
    this.marks.forEach(mark => {
      mark.redrawLine({ padding, height });
      mark.redrawNodes({ padding, curves });
    })
  }

  createMarkNode({ plotId, root, x, padding, curves, targetX, getYValue, getYMarkerText }) {
    this.nodeRoot = root.append('g')
      .attr('id', `${plotId}-mark-node-root`);
    const occupiedPoints = []
    for (let curve of curves) {
      if (select(`#${plotId}-mark-node-root`).empty()) {
        break;
      }
      const color = curve.color;
      let xCurves = curve.x, yCurves = curve.y;
      const i = getIndex(xCurves, targetX, 0, xCurves.length - 1);

      //If no point is found, exit this loop
      if (isNaN(i)) {
        continue;
      }
      const { yValue, ym } = findCoordinate({ i, xCurves, yCurves, plotId, padding, targetX, getYValue, getYMarkerText });
      const markNode = new MarkNode({
        hashId: curve.hashId,
        ym,
        yValue,
        color,
        x: x,
      });

      this.markNodes.push(markNode);
      markNode.drawIntersectionNode(this.nodeRoot, occupiedPoints);
    }
  }

  removeMarkNode(plotId) {
    if (plotId && !select(`#${plotId}-mark-node-root`).empty()) {
      select(`#${plotId}-mark-node-root`).remove();
    }
  }
}

export default MarkData;